import { Card, CardContent, Link, Stack, Typography } from '@mui/material';

import { PageHeader } from '../PageHeader';

type Attribution = {
  subject: string;
  detail: string;
  links: readonly { label: string; href: string }[];
};

const attributions: readonly Attribution[] = [
  {
    subject: 'MapLibre GL JS',
    detail: 'BSD-3-Clause licensed map rendering library.',
    links: [{ label: 'License', href: 'https://github.com/maplibre/maplibre-gl-js/blob/main/LICENSE.txt' }],
  },
  {
    subject: 'React MapLibre',
    detail: 'MIT licensed React bindings for MapLibre.',
    links: [{ label: 'License', href: 'https://github.com/visgl/react-map-gl/blob/master/LICENSE.md' }],
  },
  {
    subject: 'OpenFreeMap',
    detail: 'Vector map style and tile service used by GPS trace maps.',
    links: [{ label: 'OpenFreeMap', href: 'https://openfreemap.org/' }],
  },
  {
    subject: 'OpenMapTiles',
    detail: 'Open map data and vector-tile tooling used by the map style.',
    links: [{ label: 'OpenMapTiles', href: 'https://openmaptiles.org/' }],
  },
  {
    subject: 'OpenStreetMap contributors',
    detail: 'Map data contributors and Open Database License attribution.',
    links: [{ label: 'OpenStreetMap copyright and license', href: 'https://www.openstreetmap.org/copyright' }],
  },
];

export const AboutPage = () => (
  <>
    <PageHeader title="About" />
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h2" sx={{ fontSize: '1.25rem', fontWeight: 700 }}>
            Map acknowledgements
          </Typography>
          <Typography variant="body2" color="text.secondary">
            GPS trace maps use the following map software, style, tile, and data providers.
          </Typography>
          <Stack component="ul" spacing={1.5} sx={{ m: 0, pl: 2.5 }}>
            {attributions.map(attribution => (
              <Stack component="li" key={attribution.subject} spacing={0.25}>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>{attribution.subject}</Typography>
                <Typography variant="body2" color="text.secondary">{attribution.detail}</Typography>
                <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                  {attribution.links.map(link => (
                    <Link key={link.href} href={link.href} target="_blank" rel="noreferrer">
                      {link.label}
                    </Link>
                  ))}
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  </>
);
